import { render, staticRenderFns } from "./telphone.vue?vue&type=template&id=54b0e8bf&scoped=true&"
import script from "./telphone.vue?vue&type=script&lang=js&"
export * from "./telphone.vue?vue&type=script&lang=js&"
import style0 from "./telphone.vue?vue&type=style&index=0&id=54b0e8bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0e8bf",
  null
  
)

export default component.exports